export { VerticalBarChartComponent } from './vertical-bar-chart.component';
export { VerticalBarChartModel } from './vertical-bar-chart.model';
